import React from "react";
import { Link } from "react-router-dom";
import { resolveCmsAsset } from "../cms/media";

export default function Hero({ content = {} }) {
  const stats = content.stats || [
    { value: "2017", label: "année de création" },
    { value: "3", label: "pays d'intervention" },
    { value: "+5K", label: "clients accompagnés" },
    { value: "60", label: "collaborateurs" },
  ];
  const image = content.image || "/assets/images/hero3.jpg";

  return (
    <section
      className="site-hero position-relative d-flex align-items-center"
      style={{
        "--hero-image": `url(${resolveCmsAsset(image)})`,
      }}
    >
      <div className="container hero-container position-relative z-index-20">
        <div className="hero-panel">
          <p className="hero-kicker mb-3">
            {content.kicker || "Cabinet de formation, conseil et assistance"}
          </p>
          <h1 className="hero-title fw-bold">
            {content.title ||
              "Formations, conseil et assistance pour vos projets terrain."}
          </h1>
          <p className="hero-lead lead text-muted">
            {content.description ||
              "Fatihoune aide entreprises, institutions et particuliers à cadrer leurs besoins, renforcer les équipes et lancer les bonnes actions."}
          </p>
          <div className="hero-actions d-flex flex-column flex-sm-row gap-3">
            <Link to="/contact" className="btn btn-success">
              {content.primaryCta || "Recevoir une proposition"}
            </Link>
            <Link to="/documents" className="btn btn-outline-dark">
              {content.secondaryCta || "Voir nos habilitations"}
            </Link>
          </div>

          <div className="hero-proof-strip">
            {stats.map((stat) => (
              <div key={`${stat.value}-${stat.label}`}>
                <strong>{stat.value}</strong>
                <span className="text-muted small">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
